import React from 'react';
import { Card } from '@/components/ds';
import { AgentTimeline } from '@/components/common/AgentTimeline';

/**
 * AgentActivityTimeline — recent operational events pulled through the
 * shared AgentTimeline component. Rendered inline as a dashboard block so
 * operators can see the last 10 events without leaving the Command Center.
 */
export const AgentActivityTimeline = ({ npn }) => (
  <Card
    title="Activity Timeline"
    description="Recent operational events for this agent — contract lifecycle, invitations, portal access changes."
    testId="agent-activity-timeline"
  >
    <AgentTimeline npn={npn} limit={10} />
  </Card>
);

export default AgentActivityTimeline;
